module.exports = __webpack_public_path__ + "static/media/12-10.113ac54b.mp3";